import { DatabaseWrapper } from '../../../shared/databases/database.wrapper';
import { Database } from '../../../shared/databases/database';
import { DatabaseEnum } from 'src/app/shared/databases/databases.enum';
import { RepConnWrapper } from '../../repconn/repconn.wrapper';
import { ObjectWrapper } from 'src/app/shared/wrappers/object.wrapper';
import { Attribute } from 'src/app/shared/models/domain/attribute';

export class SnowflakeWrapper extends DatabaseWrapper {

	constructor(database: Database) {
		super(database);

		this.dbTyp_Id = DatabaseEnum.snowflake.ID;
		this.name = DatabaseEnum.snowflake.NAME;
		this.code = DatabaseEnum.snowflake.CODE;
		this.equivalentTag = DatabaseEnum.snowflake.EQUIVALENT_TAG;

		this.isShowColFormat = true;
		//data object tabs
		this.showDataObjectPropertiesTab = true;
		this.showDDLOption = true;
		this.showViewDataTabOption = true;
		this.isShowObjProperties = true;
		this.dataObjectConnDatabaseNm = 'Database';
		this.hideSchemaNmColumn = false;
		this.getSchemasOnDbNm = true;
    this.showDataDescription = false;
	}

	validateRepConn(repConnWrapper: RepConnWrapper): void {
		    
		if (repConnWrapper.repConn.conn.secKeyTab == "") {
			repConnWrapper.inValid_Cds.push('NO_ACCOUNT');
		}
		
		if (repConnWrapper.repConn.conn_Usr.conn_Usr == "") {
			repConnWrapper.inValid_Cds.push('NO_CONN_APPUSR');
		}
       if (repConnWrapper.repConn.conn.authentication == "Simple") {
		if (repConnWrapper.repConn.conn_Usr.usrPasswd == "") {
			repConnWrapper.inValid_Cds.push('NO_PASSWORD');
		}
	}
   
	

		// if (repConnWrapper.repConn.conn.wrhloc == "") {
		// 	repConnWrapper.inValid_Cds.push('NO_WRHLOC');
		// }

		if (repConnWrapper.repConn.conn.flagent_Id == -1) {
			repConnWrapper.inValid_Cds.push('ESM00202');
		}

		if (repConnWrapper.repConn.conn_Dbs.length < 1) {
			repConnWrapper.inValid_Cds.push('NO_DATABASE');
		}
		if (repConnWrapper.repConn.conn.authentication == "Key-pair") {
            if (repConnWrapper.repConn.conn.ssl_trustStore == "") {
                repConnWrapper.inValid_Cds.push('NO_TRUST_STORE_PATH');
            }
			if (repConnWrapper.repConn.conn.ssl_trustStorePassword == "") {
                repConnWrapper.inValid_Cds.push('NO_TRUST_STORE_PWD');
            }
        }
		if (repConnWrapper.repConn.conn.authentication == "PAT") {
            if (repConnWrapper.repConn.conn.accessToken == "") {
                repConnWrapper.inValid_Cds.push('ACCESS_TOKEN');
            }
			
        }

	}
	getDerivedAttributeColumns(objectWrapper: ObjectWrapper, component: any, isMax: boolean = false, attributes: Array<Attribute> = new Array<Attribute>(), isHiveNative: boolean = false): Array<any> {
		return [
			this.attributeTabulator.getCheckBoxColumn(objectWrapper),
			this.attributeTabulator.getSrt_Order(),
			this.attributeTabulator.getAttr_Id(),
			this.attributeTabulator.getAttrNm(objectWrapper,component),
			this.attributeTabulator.getAttrDTyp_Id(objectWrapper),
			this.attributeTabulator.getAttrPrec(objectWrapper),
			this.attributeTabulator.getAttrScale(objectWrapper),
			this.attributeTabulator.getMaxFlag(objectWrapper, isMax),
			//this.attributeTabulator.getOrderBy(objectWrapper, component),
			this.attributeTabulator.getPartitionflag(objectWrapper, isHiveNative),
			this.attributeTabulator.getClusterFlag(objectWrapper),
			this.attributeTabulator.getAttrExprVal(objectWrapper, component),
			this.attributeTabulator.getValid_Cd(objectWrapper, component),
		]
	}

	getAttributeColumns(objectWrapper: ObjectWrapper,
		attributes: Array<Attribute> = new Array<Attribute>(), component: any = null,hideRowSelection:boolean=true): Array<any> {
		return [
			this.attributeTabulator.getCheckBoxColumn(objectWrapper,hideRowSelection),
			this.attributeTabulator.getSrt_Order(),
			this.attributeTabulator.getAttr_Id(),
			this.attributeTabulator.getAttrNm(objectWrapper,component),
			this.attributeTabulator.getAttrDTyp_Id(objectWrapper, attributes, component),
			this.attributeTabulator.getAttrPrec(objectWrapper),
			this.attributeTabulator.getAttrScale(objectWrapper),
			this.attributeTabulator.getNotNullFlag(objectWrapper),
			this.attributeTabulator.getIdentityFlag(objectWrapper),
			this.attributeTabulator.getAttrKeyTyp_Id(objectWrapper),
			//this.attributeTabulator.getOrderBy(objectWrapper, component),
			this.attributeTabulator.getClusterFlag(objectWrapper),
			this.attributeTabulator.getDescription(objectWrapper),
		]
	}

	// getRollupSelectAttributeColumns(objectWrapper: ObjectWrapper): Array<any> {
    //     return [
    //         this.attributeTabulator.getCheckBoxColumn(objectWrapper),
    //         this.lAttributeTabulator.getSrt_Order(),
    //         this.lAttributeTabulator.getLAttr_Id(),
    //         this.lAttributeTabulator.getLAttrNm(objectWrapper),
    //         this.lAttributeTabulator.getSelectColumn(objectWrapper),
    //         this.lAttributeTabulator.getAttrDTypNm(objectWrapper),
    //         this.lAttributeTabulator.getLAttrPrec(objectWrapper),
    //         this.lAttributeTabulator.getLAttrScale(objectWrapper),
    //         this.lAttributeTabulator.getLAttrType( objectWrapper ),
    //         this.lAttributeTabulator.getLAttrFunction( objectWrapper),
    //         this.lAttributeTabulator.getDistKeyFlag(objectWrapper),
    //         this.lAttributeTabulator.getOrgKeyFlag(objectWrapper),
    //         this.lAttributeTabulator.getPartFlag(objectWrapper),
    //         this.lAttributeTabulator.getOrderBy(objectWrapper)
    //     ]
    // }

	getLAttributeColumns(objectWrapper: ObjectWrapper = null,component): Array<any> {
		return [
			this.attributeTabulator.getCheckBoxColumn(objectWrapper),
			this.lAttributeTabulator.getSrt_Order(),
			this.lAttributeTabulator.getLAttr_Id(),
			this.lAttributeTabulator.getLAttrNm(objectWrapper),
			this.lAttributeTabulator.getSelectColumn(objectWrapper),
			this.lAttributeTabulator.getAttrDTypNm(objectWrapper),
			this.lAttributeTabulator.getLAttrPrec(objectWrapper),
			this.lAttributeTabulator.getLAttrScale(objectWrapper),
			this.lAttributeTabulator.getLAttrType(objectWrapper),
			this.lAttributeTabulator.getLAttrFunction(objectWrapper),
			this.lAttributeTabulator.getOrgKeyFlag(objectWrapper),
			//this.lAttributeTabulator.getOrderBy(objectWrapper,component),
			this.lAttributeTabulator.getClusterKeyFlag(objectWrapper),
			this.lAttributeTabulator.getValid_Cd(objectWrapper)
		]
	}

	getSourceAttributeColumns(objectWrapper: ObjectWrapper = null, isShowExplodeColumn: boolean = false, isShowPIIColumn: boolean = false, isGoogleAnalytics = false, isEncryptedFlag = false, isMax: boolean = false, component: any) {
		return [
			this.attributeTabulator.getCheckBoxColumn(objectWrapper),
			this.attributeTabulator.getSrt_Order(),
			this.attributeTabulator.getAttr_Id(),
			this.attributeTabulator.getClevel(objectWrapper, isShowExplodeColumn),
			this.attributeTabulator.getAttrNm(objectWrapper,component),
			this.attributeTabulator.getColFormat(objectWrapper, isGoogleAnalytics),
			this.attributeTabulator.getAttrDTyp_Id(objectWrapper, objectWrapper.object.attributes, component),
			this.attributeTabulator.getExplodeFlag(objectWrapper, isShowExplodeColumn),
			this.attributeTabulator.getAttrPrec(objectWrapper),
			this.attributeTabulator.getAttrScale(objectWrapper),
			this.attributeTabulator.getAttrPiiIdentifierFlag(objectWrapper, isShowPIIColumn),
			this.attributeTabulator.getEncryptedFlag(objectWrapper, isEncryptedFlag),
		//	this.attributeTabulator.getOrderBy(objectWrapper, component),
			this.attributeTabulator.getClusterFlag(objectWrapper),
			this.attributeTabulator.getLnk_Attr_Id(objectWrapper),
			this.attributeTabulator.getLnk_Attr_Datatype(objectWrapper),
			this.attributeTabulator.getValid_Cd(objectWrapper, component)
		]
	}

	getConn_DbColumns(repConnWrapper: RepConnWrapper, component: any): Array<any> {
		return [
			this.conn_DbsTabultor.getCheckBoxColumn(repConnWrapper),
			this.conn_DbsTabultor.getSrt_Order(),
			this.conn_DbsTabultor.getName(repConnWrapper),
			this.conn_DbsTabultor.getDatabaseNm(repConnWrapper, component),

			//this.conn_DbsTabultor.loadShemas(repConnWrapper, component),
			this.conn_DbsTabultor.getSchemaNm(repConnWrapper, component),
			this.conn_DbsTabultor.getStgDb_Flag(repConnWrapper)
		]
	}
}
